// const BASE_URL = 'http://127.0.0.1:8000';
// const BASE_URL = 'http://172.236.156.60:8000';
const BASE_URL = 'https://kjgst.equalserp.in';

export default BASE_URL;
